// extracted by mini-css-extract-plugin
export default {"CardContainer":"Styles_CardContainer__4DpQw","recommended":"Styles_recommended__oA2vz","icon":"Styles_icon__eDFp6","name":"Styles_name__HRaDk","darkTheme":"Styles_darkTheme__SLnLt"};